import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { HttpImageLoaderService } from './http-image-loader.service';
import { GrayImage3 } from '../../image-slice-show/share/image';
import { HttpUrlEncodingCodec } from '@angular/common/http';

@Component({
  selector: 'app-http-image-loader',
  templateUrl: './http-image-loader.component.html',
  styleUrls: ['./http-image-loader.component.css'],
  providers: [HttpImageLoaderService],
})
export class HttpImageLoaderComponent implements OnInit {
  readonly inputId = uuid();
  readonly urlPlaceHolder =
    'http://192.168.1.33:5006/api/v1/CT/file?recon_id=25';

  @Input() HttpURL = 'http://192.168.1.33:5006/api/v1/CT/file?recon_id=25';
  @Output() imageLoad = new EventEmitter<GrayImage3>();
  constructor(private loaderService: HttpImageLoaderService) {}

  ngOnInit() {}

  getDummyData(url: string) {
    this.loaderService.isLoadDummyData = true;
    this.loaderService
      .getImageHttp(url)
      .subscribe((img) => this.imageLoad.emit(img), (e) => console.error(e));
  }
  getHttpImage(url: string) {
    this.loaderService.isLoadDummyData = false;
    this.loaderService
      .getImageHttp(url)
      .subscribe((img) => this.imageLoad.emit(img), (e) => console.error(e));
  }
  // getImage() {
  //   console.log(this.loaderService.image3Input);
  //   this.imageLoad.emit(this.loaderService.image3Input);
  // }
}
